import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatMessage } from '../../models';

@Component({
  selector: 'app-message-bubble',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-bubble.html',
  styleUrls: ['./message-bubble.scss'],
})
export class MessageBubbleComponent {
  @Input({ required: true }) message!: ChatMessage;
  @Input({ required: true }) isMine!: boolean;

  get timeLabel(): string {
    const d = new Date(this.message.createdOn);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  get statusIcon(): string {
    switch (this.message.status) {
      case 'sending': return '...';
      case 'sent':      return '\u2713';
      case 'delivered':  return '\u2713\u2713';
      case 'read':       return '\u2713\u2713';
      case 'failed':     return '\u26A0';
      default:           return '';
    }
  }
}
